module.exports = __webpack_public_path__ + "static/charterclub-9e95f00ae9131e00b0921a988c453e2b.jpg";